import { render } from "./QuilEditor.vue?vue&type=template&id=0c1fd868"
import script from "./QuilEditor.vue?vue&type=script&lang=js"
export * from "./QuilEditor.vue?vue&type=script&lang=js"

import "./QuilEditor.vue?vue&type=style&index=0&id=0c1fd868&lang=css"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__